"use strict";

import React, {Component} from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="login-box">
                <div className="login-logo">
                    <a href="/">VE<b>Insights</b></a>
                </div>
                <div className="login-box-body">

                    <div className="social-auth-links text-center">
                        <a href="/oauth2/authorization/gitlab" className="btn btn-block btn-flat bg-purple">
                            <i><FontAwesomeIcon icon={["fab", "gitlab"]}  /></i> &nbsp; Sign in using Glitnir
                        </a>
                    </div>

                </div>

                <br/>

                <div className="callout callout-danger">
                    <div className="card-header">
                        <h1 className="h1">
                            NOTICE
                        </h1>
                    </div>
                    <div className="card-body">
                        <p>
                            On
                            <strong> 23 June 2023 </strong>
                            the Video Enrichment Insights Dashboard will be migrating from GitLab SSO
                            to Microsoft Azure SSO for user authentication.
                        </p>
                        <p>
                            Going forward you will be required to log in using your Multichoice Group account.
                        </p>
                        <p>
                            If you require access to the Video Enrichment Insights Dashboard, please send an e-mail to
                            <strong><a className="text-white" href="mailto:albert.chan@multichoice.com"> Albert Chan </a></strong>
                            and
                            <strong><a className="text-white" href="mailto:CV-Metadata@multichoice.co.za"> CV-Metadata </a></strong>
                            in order to be assigned the correct access.
                        </p>
                    </div>
                </div>

            </div>
        )
    }
}

export default Login;
